import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
};
function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  if (!isOpen) return null;
  return <AnimatePresence data-id="element-191">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-192">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-193" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden" data-id="element-194">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-100 bg-[#1e3a5f]" data-id="element-195">
              <h2 className="text-xl font-bold text-white" data-id="element-196">{title}</h2>
              <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-lg transition-colors text-white" data-id="element-197">
                <X className="w-5 h-5" data-id="element-198" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 overflow-y-auto max-h-[calc(85vh-140px)]" data-id="element-199">
              {children}
            </div>

            {/* Footer */}
            <div className="p-4 border-t border-gray-100 bg-gray-50" data-id="element-200">
              <button onClick={onClose} className="w-full px-6 py-3 bg-[#1e3a5f] hover:bg-[#152a45] text-white font-bold rounded-lg transition-colors" data-id="element-201">
                Entendido
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}
export function TermsModal({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Términos y Condiciones" data-id="element-202">
      <div className="prose prose-sm max-w-none text-gray-700" data-id="element-203">
        <p className="text-sm text-gray-500 mb-4" data-id="element-204">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-CR', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-205">
          1. Aceptación de los Términos
        </h3>
        <p className="mb-4" data-id="element-206">
          Al acceder y utilizar los servicios de Jazugas Ingeniería
          Electromecánica ("la Empresa"), usted acepta estar sujeto a estos
          Términos y Condiciones. Si no está de acuerdo con alguna parte de
          estos términos, no podrá acceder al servicio.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-207">
          2. Descripción del Servicio
        </h3>
        <p className="mb-4" data-id="element-208">
          Jazugas ofrece servicios de asesoría y gestión para la obtención de
          certificaciones de instalaciones de gas LP en Costa Rica, de
          conformidad con la normativa vigente del Ministerio de Salud y demás
          entidades reguladoras aplicables.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-209">
          3. Requisitos del Cliente
        </h3>
        <p className="mb-4" data-id="element-210">El cliente se compromete a:</p>
        <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-211">
          <li data-id="element-212">
            Proporcionar información veraz y actualizada sobre su negocio e
            instalaciones.
          </li>
          <li data-id="element-213">
            Facilitar el acceso a las instalaciones para las inspecciones
            necesarias.
          </li>
          <li data-id="element-214">
            Cumplir con los requisitos técnicos y de seguridad establecidos por
            la normativa costarricense.
          </li>
          <li data-id="element-215">
            Realizar las correcciones o mejoras que sean necesarias para cumplir
            con los estándares requeridos.
          </li>
        </ul>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-216">
          4. Proceso de Certificación
        </h3>
        <p className="mb-4" data-id="element-217">
          El tiempo estimado de 48 horas para la certificación está sujeto a que
          el cliente cumpla con todos los requisitos técnicos y documentales. La
          Empresa no garantiza plazos específicos cuando existan incumplimientos
          o pendientes por parte del cliente.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-218">
          5. Responsabilidades de la Empresa
        </h3>
        <p className="mb-4" data-id="element-219">Jazugas se compromete a:</p>
        <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-220">
          <li data-id="element-221">
            Brindar asesoría profesional y actualizada según la normativa
            vigente.
          </li>
          <li data-id="element-222">
            Gestionar los trámites correspondientes ante las autoridades
            competentes.
          </li>
          <li data-id="element-223">Mantener la confidencialidad de la información del cliente.</li>
          <li data-id="element-224">
            Informar oportunamente sobre cualquier cambio en los requisitos o
            procesos.
          </li>
        </ul>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-225">
          6. Limitación de Responsabilidad
        </h3>
        <p className="mb-4" data-id="element-226">
          La Empresa no será responsable por demoras o denegaciones de
          certificación que resulten de: incumplimientos del cliente, cambios en
          la normativa, decisiones de las autoridades competentes, o
          circunstancias fuera del control de la Empresa.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-227">
          7. Tarifas y Pagos
        </h3>
        <p className="mb-4" data-id="element-228">
          Las tarifas por los servicios serán comunicadas previamente al
          cliente. El pago deberá realizarse según las condiciones acordadas.
          Los precios pueden estar sujetos a cambios sin previo aviso para
          nuevos servicios.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-229">
          8. Propiedad Intelectual
        </h3>
        <p className="mb-4" data-id="element-230">
          Todo el contenido de este sitio web, incluyendo textos, gráficos,
          logos y software, es propiedad de Jazugas Ingeniería Electromecánica y
          está protegido por las leyes de propiedad intelectual de Costa Rica.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-231">
          9. Legislación Aplicable
        </h3>
        <p className="mb-4" data-id="element-232">
          Estos términos se regirán e interpretarán de acuerdo con las leyes de
          la República de Costa Rica. Cualquier disputa será sometida a la
          jurisdicción de los tribunales costarricenses.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-233">
          10. Modificaciones
        </h3>
        <p className="mb-4" data-id="element-234">
          La Empresa se reserva el derecho de modificar estos términos en
          cualquier momento. Las modificaciones entrarán en vigor desde su
          publicación en este sitio web.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-235">
          11. Contacto
        </h3>
        <p className="mb-4" data-id="element-236">
          Para consultas sobre estos Términos y Condiciones, puede contactarnos
          a través de:
        </p>
        <ul className="list-none pl-0 mb-4 space-y-1" data-id="element-237">
          <li data-id="element-238">
            <strong data-id="element-239">WhatsApp:</strong> +506 8992-5929
          </li>
          <li data-id="element-240">
            <strong data-id="element-241">Correo:</strong> jazuga74@gmail.com
          </li>
        </ul>
      </div>
    </Modal>;
}
export function PrivacyModal({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Política de Privacidad" data-id="element-242">
      <div className="prose prose-sm max-w-none text-gray-700" data-id="element-243">
        <p className="text-sm text-gray-500 mb-4" data-id="element-244">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-CR', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <p className="mb-4" data-id="element-245">
          Jazugas Ingeniería Electromecánica ("nosotros", "la Empresa") se
          compromete a proteger la privacidad de sus datos personales de
          conformidad con la Ley N° 8968, Ley de Protección de la Persona frente
          al Tratamiento de sus Datos Personales de Costa Rica y su Reglamento.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-246">
          1. Información que Recopilamos
        </h3>
        <p className="mb-4" data-id="element-247">
          Podemos recopilar los siguientes tipos de información:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-248">
          <li data-id="element-249">
            <strong data-id="element-250">Datos de identificación:</strong> nombre completo, número de
            cédula o identificación.
          </li>
          <li data-id="element-251">
            <strong data-id="element-252">Datos de contacto:</strong> número de teléfono, correo
            electrónico, dirección.
          </li>
          <li data-id="element-253">
            <strong data-id="element-254">Datos del negocio:</strong> nombre comercial, ubicación,
            tipo de establecimiento.
          </li>
          <li data-id="element-255">
            <strong data-id="element-256">Datos técnicos:</strong> información sobre las instalaciones
            de gas LP.
          </li>
        </ul>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-257">
          2. Uso de la Información
        </h3>
        <p className="mb-4" data-id="element-258">Utilizamos su información personal para:</p>
        <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-259">
          <li data-id="element-260">
            Prestar los servicios de asesoría y certificación solicitados.
          </li>
          <li data-id="element-261">Comunicarnos con usted sobre el estado de su trámite.</li>
          <li data-id="element-262">Cumplir con obligaciones legales y regulatorias.</li>
          <li data-id="element-263">Mejorar nuestros servicios y atención al cliente.</li>
          <li data-id="element-264">
            Enviar información relevante sobre nuestros servicios (con su
            consentimiento).
          </li>
        </ul>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-265">
          3. Base Legal del Tratamiento
        </h3>
        <p className="mb-4" data-id="element-266">
          El tratamiento de sus datos se fundamenta en: su consentimiento
          expreso, la ejecución de un contrato de servicios, el cumplimiento de
          obligaciones legales, y/o el interés legítimo de la Empresa.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-267">
          4. Compartición de Datos
        </h3>
        <p className="mb-4" data-id="element-268">
          Sus datos personales podrán ser compartidos únicamente con:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-269">
          <li data-id="element-270">
            Autoridades gubernamentales competentes (Ministerio de Salud, etc.)
            para la gestión de certificaciones.
          </li>
          <li data-id="element-271">
            Proveedores de servicios que nos asisten en nuestras operaciones,
            bajo estrictas obligaciones de confidencialidad.
          </li>
        </ul>
        <p className="mb-4" data-id="element-272">
          No vendemos, alquilamos ni compartimos su información personal con
          terceros para fines de marketing sin su consentimiento expreso.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-273">
          5. Seguridad de los Datos
        </h3>
        <p className="mb-4" data-id="element-274">
          Implementamos medidas de seguridad técnicas y organizativas apropiadas
          para proteger sus datos personales contra acceso no autorizado,
          alteración, divulgación o destrucción.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-275">
          6. Sus Derechos
        </h3>
        <p className="mb-4" data-id="element-276">
          De acuerdo con la legislación costarricense, usted tiene derecho a:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-277">
          <li data-id="element-278">
            <strong data-id="element-279">Acceso:</strong> conocer qué datos personales tenemos sobre
            usted.
          </li>
          <li data-id="element-280">
            <strong data-id="element-281">Rectificación:</strong> solicitar la corrección de datos
            inexactos.
          </li>
          <li data-id="element-282">
            <strong data-id="element-283">Supresión:</strong> solicitar la eliminación de sus datos
            cuando ya no sean necesarios.
          </li>
          <li data-id="element-284">
            <strong data-id="element-285">Oposición:</strong> oponerse al tratamiento de sus datos en
            ciertas circunstancias.
          </li>
          <li data-id="element-286">
            <strong data-id="element-287">Revocación:</strong> retirar su consentimiento en cualquier
            momento.
          </li>
        </ul>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-288">
          7. Retención de Datos
        </h3>
        <p className="mb-4" data-id="element-289">
          Conservaremos sus datos personales durante el tiempo necesario para
          cumplir con los fines para los que fueron recopilados, incluyendo
          obligaciones legales, contables o de reporte.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-290">
          8. Cookies y Tecnologías Similares
        </h3>
        <p className="mb-4" data-id="element-291">
          Nuestro sitio web puede utilizar cookies para mejorar su experiencia
          de navegación. Puede configurar su navegador para rechazar cookies,
          aunque esto podría afectar algunas funcionalidades del sitio.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-292">
          9. Cambios a esta Política
        </h3>
        <p className="mb-4" data-id="element-293">
          Podemos actualizar esta Política de Privacidad periódicamente. Le
          notificaremos sobre cambios significativos publicando la nueva
          política en este sitio web.
        </p>

        <h3 className="text-lg font-bold text-[#1e3a5f] mt-6 mb-3" data-id="element-294">
          10. Contacto y Reclamos
        </h3>
        <p className="mb-4" data-id="element-295">
          Para ejercer sus derechos o realizar consultas sobre esta política,
          contáctenos:
        </p>
        <ul className="list-none pl-0 mb-4 space-y-1" data-id="element-296">
          <li data-id="element-297">
            <strong data-id="element-298">WhatsApp:</strong> +506 8992-5929
          </li>
          <li data-id="element-299">
            <strong data-id="element-300">Correo:</strong> jazuga74@gmail.com
          </li>
        </ul>
        <p className="mb-4" data-id="element-301">
          Si considera que sus derechos han sido vulnerados, puede presentar una
          denuncia ante la Agencia de Protección de Datos de los Habitantes
          (PRODHAB) de Costa Rica.
        </p>
      </div>
    </Modal>;
}